import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetParticipantsTerminatedsBySociogram = sociogramId => {
  const query = useApiQuery(
    ['participantsTerminatedBySociogram', `sociogramId: ${sociogramId}`],
    'sociogram',
    `/sociograms/${sociogramId}/participants-terminateds`,
    { enabled: !!sociogramId }
  )

  return {
    isLoadingParticipantsTerminated: query.isLoading,
    isFetchingParticipantsTerminated: query.isFetching,
    participantsTerminated: query.data ?? [],
    errorParticipantsTerminated: query.isError ? query.error : null,
    getParticipantsTerminateds: query.refetch
  }
}
